export default{
    proformaBillRow: {
        index: 'proforma-bill-row-index',
    }
}